import React, { useState } from "react";
import "./Contact.css";
import { sending_mail, thankyou, typeWriter } from "../../assets/gifs";
import CustomModal from "../../components/Modal/Modal";
import { selectHeading } from "../../store/globalSlice";
import { useSelector } from "react-redux";
import { Failed } from "../../assets/images";
import emailjs from "emailjs-com";
import { mailserviceId, mailtemplateId, mailuserId } from "../../shared/config";
import { useCursor } from "../../shared/config/cursorProvider";

const Contact = () => {
  const noHeading = useSelector(selectHeading);
  const cursorPosition = useCursor()
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [showThankYou, setShowThankYou] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSending(true);
      const serviceId = mailserviceId
      const templateId = mailtemplateId
      const userId = mailuserId

      const formDataForEmailJS = {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
      };
      

      const result = await emailjs.send(
        serviceId,
        templateId,
        formDataForEmailJS,
        userId
      );

      console.log("Email sent successfully", result);

      setFormData({
        name: "",
        email: "",
        message: "",
      });

      setShowThankYou(true);
    } catch (error) {
      setFailed(true);
      console.error("Error sending email:", error);
    } finally {
      setIsSending(false);
    }
  };

  const closeThankYouPopover = () => {
    setShowThankYou(false);
  };

  return (
    <div className="contact-form-container">
      <div className="custom-1" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
      <div className="custom-cursor" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
      {!noHeading && (
        <div className="contact-container">
          <h1>Let's make something together.</h1>
          <p>
            Your Thoughts Matter: We're Excited to Connect and Collaborate with
            You!
          </p>
        </div>
      )}
      <div className="contact-form-box">
        <div className="typewriter">
          <img src={typeWriter} alt="" />
        </div>
        <form onSubmit={handleSubmit} className="contact-form">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="message">Message:</label>
          <textarea
            style={{ height: noHeading ? "" : "220px" }}
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" className="submit-contact">
            Send Message
          </button>
        </form>
      </div>
      {showThankYou && (
        <CustomModal onClose={closeThankYouPopover}>
          <img src={thankyou} alt="" />
          <p>Thank you for your message!</p>
        </CustomModal>
      )}
      {failed && (
        <CustomModal onClose={() => setFailed(false)}>
          <div className="failed-block">
            <img src={Failed} className="failed-to-upload" alt="" />
            <p>Something Went Wrong! Mail us at zivotixhq@gmail.com</p>
          </div>
        </CustomModal>
      )}
      {isSending && (
        <CustomModal contact>
          <img src={sending_mail} alt="" />
        </CustomModal>
      )}
    </div>
  );
};

export default Contact;
